/* eslint-disable no-param-reassign */
import Vue from 'vue';
import mutations from './filters.mutationlist';
import { searchCategoryByKeywords } from '@/utils'

/* eslint no-param-reassign: [
  "error", { "props": true, "ignorePropertyModificationsFor": ["state"] }
] */
export default {
  [mutations.FILTER_SET]: (state, { key, value }) => {
    if (key === 'search') {
      // Check if it matches any category/subcategory
      const { category, subcategory } = searchCategoryByKeywords(value);
      Vue.set(state, 'category', category);
      Vue.set(state, 'subcategory', subcategory);
      Vue.set(state, key, value);
      Vue.set(state, 'keywordMatchedCategory', !!category);
    } else {
      Vue.set(state, key, value);
    }
  },
  [mutations.SELECT_CATEGORY]: (state, payload) => {
    Vue.set(state, 'category', payload);
    Vue.set(state, 'subcategory', null);
  },
  [mutations.REMOVE_CATEGORY]: (state) => {
    Vue.set(state, 'category', null);
    Vue.set(state, 'subcategory', null);
  },
  [mutations.REMOVE_SUBCATEGORY]: (state) => {
    Vue.set(state, 'subcategory', null);
  },
  [mutations.REMOVE_ATTRIBUTE]: (state, atTypeId) => {
    Vue.set(state, 'dynamic', {
      ...state.dynamic,
      [`_${atTypeId}`]: undefined,
    });
  },
  [mutations.SELECT_SUBCATEGORY]: (state, payload) => {
    Vue.set(state, 'subcategory', payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/filters/filters.mutations.js